import { COMPANY } from '../company';
import type { LegalDoc } from './types';

/** Unchanged in substance from the previous refund policy; reformatted as a numbered document. */
export const REFUNDS: LegalDoc = {
  title: 'Refund policy',
  summary: 'If something goes wrong with a payment or a report, tell us and we will put it right.',
  updated: '28 September 2026',
  sections: [
    {
      id: 'full-refund',
      heading: 'Full refund',
      blocks: [
        'We refund in full within 7 days of payment if the report was not downloaded or delivered to you, or if you were charged more than once for the same report.',
      ],
    },
    {
      id: 'duplicate-charges',
      heading: 'Duplicate charges',
      blocks: ['If a duplicate charge appears, contact us and we will refund it. We also investigate every duplicate as a fault on our side.'],
    },
    {
      id: 'after-delivery',
      heading: 'After the report has been delivered',
      blocks: [
        'Because the report is a digital product prepared specifically for your child, we do not routinely refund after it has been delivered. If something went wrong with your report, tell us. We will reissue it, or refund at our discretion.',
      ],
    },
    {
      id: 'nurture-plus',
      heading: 'Nurture Plus',
      blocks: [
        'You can cancel Nurture Plus at any time in Settings. Cancelling stops the next charge; the current quarter is not refunded, and you keep its unlocks until it ends.',
      ],
    },
    {
      id: 'how-to-ask',
      heading: 'How to ask',
      blocks: [
        `Email [${COMPANY.supportEmail}](mailto:${COMPANY.supportEmail}) with your report reference. Refunds go back to the original payment method, usually within 5 to 7 working days, and the report is locked again once the refund is issued.`,
      ],
    },
  ],
};
